import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getBackendUrl } from '../../lib/env';

const API_URL = getBackendUrl();
export const JJUMA_HOME_URL = 'https://jjuma.com';

function pickLogoUrl(branding = {}) {
  return branding.logo_url || branding.checkout_logo_url || branding.receipt_logo_url || branding.light_logo_url || branding.dark_logo_url || '';
}

export default function CheckoutBrandHeader({
  branding: brandingProp,
  className = '',
  compact = false,
  showTagline = true,
  homeUrl = JJUMA_HOME_URL,
}) {
  const [remoteBranding, setRemoteBranding] = useState(null);

  useEffect(() => {
    if (brandingProp) {
      setRemoteBranding(brandingProp);
      return undefined;
    }

    let mounted = true;
    axios.get(`${API_URL}/api/branding/public`).then((response) => {
      if (mounted) {
        setRemoteBranding(response.data || {});
      }
    }).catch(() => {
      if (mounted) {
        setRemoteBranding({});
      }
    });

    return () => {
      mounted = false;
    };
  }, [brandingProp]);

  const branding = brandingProp || remoteBranding || {};
  const logoUrl = pickLogoUrl(branding);
  const tagline = branding.brand_tagline || 'Jjuma Pay';

  return (
    <div className={`mx-auto w-full max-w-3xl ${className}`}>
      <a
        href={homeUrl}
        className="group inline-flex w-full items-center justify-center"
        aria-label="Go to Jjuma home page"
      >
        {logoUrl ? (
          <img
            src={logoUrl}
            alt="Jjuma logo"
            className={`object-contain transition-transform duration-200 group-hover:scale-[1.01] ${compact ? 'h-10 sm:h-12' : 'h-12 sm:h-14'}`}
          />
        ) : (
          <div className={`flex items-center justify-center rounded-full border border-emerald-100 bg-white text-emerald-800 shadow-sm ${compact ? 'h-10 px-4' : 'h-12 px-5'}`}>
            <span className={`font-semibold tracking-wide ${compact ? 'text-sm' : 'text-base'}`}>Jjuma Pay</span>
          </div>
        )}
      </a>
      {showTagline && (
        <p className="mt-2 text-center text-xs text-slate-500">
          {tagline}
        </p>
      )}
    </div>
  );
}
